import { useSelector } from 'react-redux';
import { getHistoryBaccarat } from '../selectors';

export const useGameHistory = () => useSelector(getHistoryBaccarat);
